import axios from "axios";

// Retrieve backend URL from session storage, or use a default value
// const storedBackendUrl =
//   window.sessionStorage.getItem("backendUrl") ||
//   "http://" + window.location.hostname.toString() + ":3000/api";

  //   const storedBackendUrl =
  // window.sessionStorage.getItem("backendUrl") ||
  // "https://elgservices.com.lk/api";

  const storedBackendUrl =
  window.sessionStorage.getItem("backendUrl") ||
  "https://elgservices.com.lk/acc";
  
  //  const storedBackendUrl =
  // window.sessionStorage.getItem("backendUrl") ||
  // "https://elgservices.lk/api";

// Set Axios defaults
axios.defaults.baseURL = storedBackendUrl;
axios.defaults.withCredentials = false; // or `true` if needed

// Optionally, log the base URL for debugging purposes
console.log(`Axios base URL set to: ${axios.defaults.baseURL}`);

// Export Axios instance for use in your application
export default axios;


// import axios from "axios";

// // Determine backend URL
// const backendUrl =
//   window.sessionStorage.getItem("backendUrl") ||
//   `http://${window.location.hostname}:3000/api`; // fallback for local dev
// // const backendUrl = "https://elgservices.lk/api"; // Uncomment for production

// // Set Axios defaults
// axios.defaults.baseURL = backendUrl;
// axios.defaults.withCredentials = false; // set true if your API requires cookies
// console.log(`Axios base URL set to: ${axios.defaults.baseURL}`);

// // Automatically attach JWT token to every request
// axios.interceptors.request.use(
//   (config) => {
//     const token = sessionStorage.getItem("authToken");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Handle 401 Unauthorized globally
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       sessionStorage.removeItem("authToken");
//       sessionStorage.removeItem("userData");
//       alert("Session expired. Please log in again.");
//       window.location.href = "/login"; // redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

// // Optional: make axios available globally
// window.axios = axios;

// Optional: export axios instance for module imports
// export default axios;
